// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import {
    createElement,
    Translate,
    PropTypes,
    Panel,
    Button,
    Icon,
} from '@plesk/ui-library';
import Link from '../../../../plesk/Link';

const Setup = props => {
    const {
        addDomainUrl,
        openTutorialUrl,
        addDomainBannerSrc,
        baseClassName,
    } = props;
    return (
        <Panel className={baseClassName}>
            <div className={`${baseClassName}__content`}>
                <figure className={`${baseClassName}__banner`}>
                    <img
                        className={`${baseClassName}__banner-image`}
                        src={addDomainBannerSrc}
                        width="600"
                        height="214"
                        alt=""
                    />
                </figure>
                <p className={`${baseClassName}__lead`}><Translate content="description" /></p>
                <Button
                    component={Link}
                    to={addDomainUrl}
                    className={`${baseClassName}__button`}
                    icon={
                        <Icon className={`${baseClassName}__button-icon`}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path d="m1,9h8v-8h6v8h8v6h-8v8h-6v-8h-8v-6z" />
                            </svg>
                        </Icon>
                    }
                    intent="primary"
                    id="buttonAddDomain"
                >
                    <Translate content="addDomain" />
                </Button>
                <div>
                    <Link
                        to={openTutorialUrl}
                        target="_blank"
                        id="linkOpenTutorial"
                        className="text-color--muted-light"
                    >
                        <Translate content="openTutorial" />
                    </Link>
                </div>
            </div>
        </Panel>
    );
};

Setup.propTypes = {
    addDomainUrl: PropTypes.string.isRequired,
    openTutorialUrl: PropTypes.string.isRequired,
    addDomainBannerSrc: PropTypes.string.isRequired,
    baseClassName: PropTypes.string,
};

Setup.defaultProps = {
    baseClassName: 'web-setup-panel',
};

export default Setup;



// WEBPACK FOOTER //
// ./views/smb/web/setup/Setup.js